setTimeout(function(){
    $('.main-get-help h6').bind('click',function(){
        let attr = 'open';
        if($(this).attr(attr)){
            $(this).removeAttr(attr);
        }else{
            $(this).attr(attr, attr);
        }
    });
    $('.full-width h6').bind('click',function(){
        let attr = 'open';
        if($(this).attr(attr)){
            $(this).removeAttr(attr);
        }else{
            $(this).attr(attr, attr);
        }
    });
},100);